<template>
  <header-base>
    <div class="container" v-if="stepsTaken.length">
      <transition-group
        tag="div"
        class="steps"
        :name="animationDirection"
        :duration="{leave: 250, enter: 500}"
      >
        <step
          v-for="(step, index) in stepsTaken"
          :key="'step_' + index"
          :step="step"
          :step-index="index"
        ></step>
        <finish
          v-if="isFinished"
          :key="'step_' + stepsTaken.length"
          :resultAmount="productAmount"
        ></finish>
      </transition-group>
    </div>
  </header-base>
</template>

<script>
import { mapGetters, mapState, } from "vuex";
import Step from "@/components/library/Step";
import HeaderBase from "@/components/layout/HeaderBase";
import Finish from '@/components/library/Finish.vue';

export default {
  name: "StepHeader",

  components: {
    HeaderBase,
    Step,
    Finish,
  },

  computed: {
    ...mapState({
      stepsTaken: (state) => state.preference.stepsTaken,
    }),
    ...mapGetters('preference', [
      'animationDirection',
      'isFinished'
    ]),
    ...mapGetters('products', [
      'productAmount'
    ]),
  },
}
</script>

<style scoped lang="scss">
.slide-enter-active {
  transform-origin: left top;
}

.slide-enter,
.slide-leave-to {
  transform: scale(0);
  transform-origin: left top;
}
</style>
